import React, { useEffect, useState } from 'react';
import { getConfig } from 'next';

const { publicRuntimeConfig } = getConfig();

export type imgProps = JSX.IntrinsicElements['img'];
export interface ImgProps extends imgProps {
  src: string;
  alt: string;
}

const imgSrc = (src: string) => {
  let validatedSrc;

  if (src.startsWith('/')) {
    validatedSrc = `${publicRuntimeConfig.ASSETS_URL}${src}`;
  } else {
    validatedSrc = src;
  }
  return validatedSrc;
};

const Img = (props: ImgProps) => {
  const { src, alt, loading, ...rest } = props;
  const [source, setSource] = useState('');

  useEffect(() => {
    if (loading === 'lazy') {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setSource(imgSrc(src));
            observer.unobserve(document.body);
          }
        });
      });

      observer.observe(document.body);
    } else {
      setSource(imgSrc(src));
    }
  }, [loading, src]);

  if (typeof window === 'undefined') return <img src={imgSrc(src)} alt={alt} {...rest} />;

  return <img src={source} alt={alt} {...rest} />;
};

export { Img, imgSrc };
export default Img;
